import { Component, Input } from '@angular/core';
import { UpdateComponent } from '@app/shared/components/base/update.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vin-input',
  templateUrl: './vin.component.html',
  styleUrls: ['./vin.component.scss']
})
export class VinComponent extends UpdateComponent {

  private _vin: string;
  private checkDigit: string;

  public readonly maxLenght = 17;

  get labelText() {
    return this.translateService.instant('vehicle.vin') + (this.checkDigit ? ` - ${this.translateService.instant('vehicle.vin_check', { checkDigit: this.checkDigit })}` : '');
  }

  @Input()
  set vin(vin: string) {
    this._vin = vin;
    this.checkDigit = this.generateVinCheckDigit(this._vin);
  }

  get vin() {
    return this._vin;
  }

  constructor(protected translateService: TranslateService) {
    super();
  }

  private generateVinCheckDigit(vin: string): string {

    if (!vin || vin.length !== 17) {
      return ''; // vin must have 17 chars
    }

    vin = vin.toUpperCase();

    let weight = 2;
    let sum = 0;
    let ii = 16;
    let result;

    while (ii >= 0) {
      const cc = this.charToDigit(vin.charAt(ii--));

      if (cc < 0) {
        return ''; // wrong digit, return
      }

      sum += (cc * weight++);

      if (weight > 10) {
        weight = 2;
      }
    }

    sum = sum % 11;

    if (sum === 10) {
      result = 'X';
    } else {
      result = sum.toString();
    }
    return result;
  }

  private charToDigit(char): number {
    switch (char) {
      case 'A':
      case 'J':
      case '\xC4':
      case '1':
        return 1;
      case 'B':
      case 'K':
      case 'S':
      case '2':
        return 2;
      case 'C':
      case 'L':
      case 'T':
      case '3':
        return 3;
      case 'D':
      case 'M':
      case 'U':
      case '\xDC':
      case '4':
        return 4;
      case 'E':
      case 'N':
      case 'V':
      case '5':
        return 5;
      case 'F':
      case 'W':
      case '6':
        return 6;
      case 'G':
      case 'P':
      case 'X':
      case '7':
        return 7;
      case 'H':
      case 'Q':
      case 'Y':
      case '8':
        return 8;
      case 'I':
      case 'R':
      case 'Z':
      case '9':
        return 9;
      case 'O':
      case '\xD6':
      case '0':
        return 0;
    }
    return -1;
  }
}
